/**
 * A minimal, discoverable "?" affordance that surfaces the keyboard-shortcut
 * keymap on hover/focus. Keeps the shortcuts learnable without a heavy modal —
 * the keymap itself is the single source shared with useKeyboardShortcuts.
 */
import { KeyboardIcon } from '@phosphor-icons/react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@andavo/web-ui';
import { SHORTCUTS } from '../hooks/useKeyboardShortcuts';

export function ShortcutsHint() {
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            aria-label="Keyboard shortcuts"
            // data-testid="shortcuts-hint" — the discoverability affordance; the
            // e2e chat spec can hover it to reveal the keymap (selectors.ts
            // shortcutsHint).
            data-testid="shortcuts-hint"
            className="rounded-md p-1.5 text-content-secondary transition-colors hover:bg-surface-foreground hover:text-content-primary"
            type="button"
          >
            <KeyboardIcon className="size-icon-sm" />
          </button>
        </TooltipTrigger>
        <TooltipContent side="top">
          <ul className="flex flex-col gap-1">
            {SHORTCUTS.map((s) => (
              <li
                className="flex items-center justify-between gap-4 text-xs"
                key={s.label}
              >
                <span className="text-content-secondary">{s.label}</span>
                <kbd className="font-mono text-content-primary">{s.keys}</kbd>
              </li>
            ))}
          </ul>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
